<template>
  <v-card tile>
    <v-card-title class="pl-0">
      <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>留言反馈
      <v-spacer />
      <v-text-field dense rounded hide-details label="搜索关键词" single-line v-model="queryParam.searchValue" outlined prepend-inner-icon="mdi-magnify" @keydown.native="onSearchValueKeydown" />
    </v-card-title>
    <v-card-text>
      <!-- <v-row justify="end" class="mt-2 mb-6">
        <v-col cols="5">
          <v-text-field dense rounded hide-details label="搜索关键词" single-line v-model="queryParam.searchValue" outlined prepend-inner-icon="mdi-magnify" @keydown.native="onSearchValueKeydown" />
        </v-col>
      </v-row> -->
      <v-data-table dense :headers="headers" :items="dataList" hide-default-footer disable-sort>
        <template v-slot:item.sn="{ item }">{{dataList.indexOf(item)+1}}</template>
        <template v-slot:item.title="{ item }">
          <router-link :to="`/profile/msgboard/${item.id}`">{{item.title}}</router-link>
        </template>
        <template v-slot:item.ct="{ item }">{{ Utility.fmtDt(item.ct) }}</template>
      </v-data-table>
      <v-pagination v-if="pagination.num>1" v-model="pagination.index" :length="pagination.num" :total-visible="pagination.size" @input="onPage" />
    </v-card-text>
  </v-card>
</template>
<script>
/* eslint-disable no-console */
import { userQaQuery } from '@/plugins/api';
export default {
  data () {
    return {
      headers: [
        { text: '#', value: 'sn' },
        { text: '标题', value: 'title' },
        { text: '提交时间', value: 'ct' },
        { text: '', value: 'action' }
      ],
      dataList: [],
      pagination: { index: 1, size: 10, num: 0, total: 0 },
      queryParam: { searchValue: '' }
    }
  },
  methods: {
    dataQuery (param) {
      userQaQuery(param).then(res => {
        this.dataList = res.data;
        this.pagination = res.pagination;
      })
    },
    onPage () {
      let param = { ...this.queryParam, pagination: { index: this.pagination.index, size: this.pagination.size } }
      this.dataQuery(param);
    },
    onSearch () {
      let param = { ...this.queryParam, pagination: { index: 1, size: this.pagination.size } }
      this.dataQuery(param);
    }
  },
  created () {
    this.onSearch()
  }
}
</script>